import { render, staticRenderFns } from "./BookingClientName.vue?vue&type=template&id=6efff2d8&"
import script from "./BookingClientName.vue?vue&type=script&lang=ts&"
export * from "./BookingClientName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports